import { makeLegend, makeLegendMinMax } from 'utils/utils';
import {
  ColorLibrary,
  colorFromSteps,
  colorMapsFromMinMaxFactory,
  constantStepCalculator
} from '../../utils/color-maps';


export default   {
  sectionText: "Physical Geography",
  section: "geography",
  components: [
    {
      text: 'Topography',
      type: 'switch',
      stateProperty: 'topographyLayerIsShowing',
      layerType: 'topography',
      layerConfig: {
        url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/topography/DEM_all_states_cogeo.tif',
        name: 'topography',
        title: 'Topography (12,5m res) - (m above MSL)',
        id: 'topography',
        legend: [
          {'text': '-100 - 0', 'color': '#336600' },
          {'text': '0 - 50', 'color': '#72B219' },
          {'text': '50 - 100', 'color': '#CAE683' },
          {'text': '1000 - 150', 'color': '#FEF4B5' },
          {'text': '150 - 300', 'color': '#f9db82' },
          {'text': '300 - 500', 'color': '#f5c24e' },
          {'text': '500 - 750', 'color': '#9c6721' },
          {'text': '750 - 1000', 'color': '#663307' },
          {'text': '1000 - 1500', 'color': '#714112' },
          {'text': '1500 - 2000', 'color': '#ab8f73' },
          {'text': '2000 - 2200', 'color': '#e6ddd5' },
        ],
        pixelValuesToColorFn: (([value]) => {
          if (value < -100) return `rgba(0,0,0,0)`;
      
          if (value < 0) return '#336600'
          if (value < 50) return '#72B219'
          if (value < 100) return '#CAE683'
          if (value < 150) return '#FEF4B5'
          if (value < 300) return "#f9db82"
          if (value < 500) return "#f5c24e"
          if (value < 750) return "#9c6721"
          if (value < 1000) return "#663307"
          if (value < 1500) return "#714112"
          if (value < 2000) return "#ab8f73"
          return "#e6ddd5"
        }),
        opacity: 0.7,
        resolution: 128,
        zIndex: 420
      }
    },
    {
      text: 'High Res Topography',
      type: 'switch',
      stateProperty: 'highResTopographyLayerIsShowing',
      layerType: 'topography',
      layerConfig: {
        url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/topography/merged_hi_res_cogeo.tif',
        name: 'highResTopography',
        id: 'highResTopography',
        title: 'Topography (5m res, AW3D Product from NTTData) - (m above MSL)',
        legend: [
          {'text': '-100 - 0', 'color': '#336600' },
          {'text': '0 - 50', 'color': '#72B219' },
          {'text': '50 - 100', 'color': '#CAE683' },
          {'text': '1000 - 150', 'color': '#FEF4B5' },
          {'text': '150 - 300', 'color': '#f9db82' },
          {'text': '300 - 500', 'color': '#f5c24e' },
          {'text': '500 - 750', 'color': '#9c6721' },
          {'text': '750 - 1000', 'color': '#663307' },
          {'text': '1000 - 1500', 'color': '#714112' },
          {'text': '1500 - 2000', 'color': '#ab8f73' },
          {'text': '2000 - 2200', 'color': '#e6ddd5' },
        ],
        pixelValuesToColorFn: (([value]) => {
          if (value < -100) return `rgba(0,0,0,0)`;
      
          if (value < 0) return '#336600'
          if (value < 50) return '#72B219'
          if (value < 100) return '#CAE683'
          if (value < 150) return '#FEF4B5'
          if (value < 300) return "#f9db82"
          if (value < 500) return "#f5c24e"
          if (value < 750) return "#9c6721"
          if (value < 1000) return "#663307"
          if (value < 1500) return "#714112"
          if (value < 2000) return "#ab8f73"
          return "#e6ddd5"
        }),
        opacity: 0.7,
        resolution: 128,
        zIndex: 420
      }
    },
    {
      text: 'Landuse',
      type: 'switch',
      stateProperty: 'landuseLayerIsShowing',
      layerType: 'rasterfile',
      layerConfig: {
        url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/topography/mosaic_all_states_with_paddy-cogeo.tif',
        name: 'landuse',
        id: 'landuse',
        title: 'Land use',
        attributionString: 'Land use',
        pixelValuesToColorFn: ([value]) => {
          switch (value) {
            case 1: return '#e9a213'
            case 2: return '#12a708'
            case 3: return '#ef8c97'
            case 4: return '#a10107'
            case 5: return '#ce82e7'
            case 6: return '#78008a'
            case 7: return '#020001'
            case 8: return '#ccef86'
            case 9: return '#807585'
            
          }
        },
        legend: [
          {color: '#e9a213', text: 'Agriculture (non-paddy)'},
          {color: '#12a708', text: 'Agriculture (paddy)'},
          {color: '#ef8c97', text: 'Rural Residential'},
          {color: '#a10107', text: 'Urban Residential'},
          {color: '#ce82e7', text: 'Commercial and Institutional'},
          {color: '#78008a', text: 'Industrial and Infrastructure'},
          {color: '#020001', text: 'Roads'},
          {color: '#ccef86', text: 'Others'},
          {color: '#807585', text: 'Urban'},
        ],
        opacity: 1,
        resolution: 96,
        zIndex: 420
      }
    },
    {
      text: 'River network',
      type: 'switch',
      stateProperty: 'rivernetworkLayerIsShowing',
      layerType: 'shapefile',
      shapeFileConfig: {
        url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/rivers/RiverNetworkTree.zip',
        name: 'Lakes',
        title: 'Lakes',
        attributionString: 'Unknown',
        style: () => {
          return {
            stroke: true,
            weight: 1,
            color: '#007af8',
            fillOpacity: 1
          }
        },
        legend: [
          {color: '#007af8', text: 'River network'}
        ]
      }
    },
    // {
    //   text: 'Global Surface Water',
    //   type: 'switch',
    //   stateProperty: 'gswLayerIsShowing',
    //   layerType: 'rasterfile',
    //   layerConfig: {
    //     url: 'https://tiff-library.s3.eu-west-2.amazonaws.com/malaysia/rivers/global_surface_water_cogeo.tif',
    //     name: 'landuse',
    //     id: 'landuse',
    //     title: 'GSW (% of time present)',
    //     legend: [
    //       {color: '#99d9ea', text: '5 - 50'},
    //       {color: '#08306b', text: '50 - 100'},

    //     ],
    //     attributionString: 'Global Surface water',
    //     pixelValuesToColorFn: ([value]) => {
    //       if (value < 5) {
    //         return ColorLibrary.transparent
    //       }
    //       if (value < 50) {
    //         return '#99d9ea'
    //       }
    //       if (value <= 100) {
    //         return '#08306b'
    //       }
    //       return ColorLibrary.transparent

    //     },
    //     opacity: 1,
    //     resolution: 96,
    //     zIndex: 420
    //   }
    // }
  ]
}